import { useEffect, useState } from "react";
import { NARROW_QUERY, matchesNarrow } from "../lib/viewport";

/**
 * Follows the viewport instead of reading it once. Rotating a phone, or
 * dragging a desktop window narrow, has to move the sidebar with it; a value
 * read at mount would leave the layout wrong until a reload.
 */
export default function useIsNarrow() {
  const [narrow, setNarrow] = useState(() => matchesNarrow());

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;

    const query = window.matchMedia(NARROW_QUERY);
    const onChange = (event) => setNarrow(Boolean(event.matches));

    // The width can already have changed between the first render and this
    // effect, so start from what the query says now.
    setNarrow(Boolean(query.matches));

    // addListener is the Safari 13 spelling. The desktop app ships its own
    // Chromium, but the PWA runs in whatever browser the user has.
    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", onChange);
      return () => query.removeEventListener("change", onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return narrow;
}
